import React, {Component, Fragment} from 'react';

import './RemedialTrainingResponse.scss';
import CustomForm from "../../../../shared/components/form/CustomForm";
import DisplayBoolean from "../../../../shared/forms/DisplayBoolean";
import {validateRequired, validateNumber} from "../../../../shared/components/form/ValidationFunctions";
import classNames from 'classnames';
import {ApiGet} from "../../../../shared/services/api-service";
import {formatDate} from "../../../../shared/services/utils/utils";
import reportModel from "../../../models/report";
import moment from "moment/moment";

function getHoursAndMinutes(date = new Date()) {
  return padTo2Digits(date.getHours()) + ':' + padTo2Digits(date.getMinutes());
}

function padTo2Digits(num) {
  return String(num).padStart(2, '0');
}

let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

class LogFieldResponse extends Component {
  constructor(props) {
    super(props);
    let dt = null
    let dateTime = props.datetime && props.datetime.datetime ? moment(props.datetime.datetime) : moment(new Date)
    dt = dateTime.format('YYYY-MM-DD')
    // try {
    //   dt = props.datetime && props.datetime.datetime ? props.datetime.datetime.toString().split('T')[0] : (new Date).toISOString().split('T')[0]
    // } catch (ex) {
    // }

    console.log('DATE TEIME', dt, props.datetime)

    this.state = {
      isFormOpened: false,
      editingLogIndex: null,
      datetime: dt,
      isAdding: false,
      editingItem: null
    }
  }

  get value() {
    return this.props.value && this.props.value.list || []
  }

  get isEdit() {
    return this.props.isEdit !== false
  }

  get logFieldGenericConfig() {
    let filedsWithRules = [];

    if (this.props.element && this.props.element.fields) {
      this.props.element.fields.reduce(function (acc, field) {
        let rulesList = [];
        if (field.required) {
          rulesList.push(validateRequired(field.label))
        }

        if (field.isNumber) {
          rulesList.push(validateNumber(field.label));
        }

        field.rules = rulesList;
        filedsWithRules.push(field);

        return acc;
      }, []);
    }

    let resultConfig = {
      form_title: this.props.element ? this.props.element.form_title: "",
      fields: {...filedsWithRules},
      groupBy: this.props.element ? this.props.element.groupBy : []
    }

    return resultConfig;
  }

  componentDidMount() {
    this.props.onValueChange && this.props.onValueChange(this.props.name, {
      ...this.props.value,
      isValid: true,
    });

    if (this.props.element.pullTylerCADData && (!this.props.value.list || !this.props.value.list.length)) {
      this.syncCADData()
    }
    if (this.props.element.pullIcsCADData && (!this.props.value.list || !this.props.value.list.length)) {
      this.syncIcsCADData()
    }
    if (this.props.element.pullCmpdCADData && (!this.props.value.list || !this.props.value.list.length)) {
      this.syncCmpdCADData()
    }
    if (this.props.element.pullLenexaCADData && (!this.props.value.list || !this.props.value.list.length)) {
      this.syncLenexaCADData()
    }
  }

  syncCADData(clear = false) {
    if (!this.isEdit) {
      return false
    }
    if (clear) {
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: false,
        list: []
      })
    }
    ApiGet(`/api/v1/tyler-cad/list-by-user/${this.props.acknowledger.guid}/${this.state.datetime}`).then(res => {
      res.forEach((log) => {
        /***
         call_id:"4095610"
         call_number:102
         date:"2023-04-01T10:03:03"
         id:"0e831c0a-68ca-40bf-95de-c5623e52e8b1"
         incident_number:"2023-00044513"
         is_primary:true
         latitude:"27.504901209583"
         location:"801 HIDALGO ST, LRDO"
         longitude:"-99.5036128516976"
         officer_id:"3181"
         shield:"1051"
         type:"VAGRANT DISTURBING"
         */
        this.onAddLog({
          0: getHoursAndMinutes(new Date(log.date)),
          1: '',
          2: log.type && log.type.toLowerCase().replace(' ', '_'),
          3: log.location,
          4: log.incident_number,
          5: log.is_primary ? 'primary' : 'assisted',
          6: ''
        })
      })
    })
  }

  syncIcsCADData(clear = false) {
    if (!this.isEdit) {
      return false
    }
    if (clear) {
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: false,
        list: []
      })
    }
    ApiGet(`/api/v1/ics-cad/list-by-user/${this.props.acknowledger.guid}/${this.state.datetime}`).then(res => {
      res.forEach((log) => {
        /***
         call_id: "91309"
         call_number: "24038904"
         date: "2024-08-30T19:33:55"
         fleet_number: "P431"
         id: "daf53b21-2171-4158-a937-c5576e1e57f1"
         is_primary: true
         latitude: "29.5230860557399"
         location: "16700 OXNARD LN , FRIENDSWOOD, TX 77546"
         longitude: "-95.1823961230926"
         officer_id: "1234"
         shield: "2329"
         type: "RESIDENTIAL PATROL"
         type_id: "RESIDENTIAL PATROL"
         */
        let existing = this.value.find(v => {
          return v[0] === log.type && `${log.type} - ${log.type_id}`
           && v[1] === log.is_primary ? 'primary' : 'backup'
           && v[3] === log.call_number
        })
        if(!existing) {
          this.onAddLog({
            0: log.type && `${log.type} - ${log.type_id}`,
            1: log.is_primary ? 'primary' : 'backup',
            2: '',
            3: log.call_number,
          })
        }

      })
    })
  }
  syncCmpdCADData(clear = false) {
    if (!this.isEdit) {
      return false
    }
    if (clear) {
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: false,
        list: []
      })
    }
    ApiGet(`/api/v1/cmpd-cad/list-by-user/${this.props.acknowledger.guid}/${this.state.datetime}`).then(res => {
      res.forEach((log) => {
        /***

         arrive_time:"2025-04-09T12:32:06"
         beat:"2612"
         cad_event_number:"Z0409123101"
         city:"CHARLOTTE"
         complaint_number:"20250409123101"
         dispatch_time:"2025-04-09T12:31:24"
         disposition:"CHARLOTTE"
         disposition_time:"2025-04-09T15:24:00"
         division:"26"
         fleet_number:"PDA1191"
         id:"64875a7a-4756-4830-82ef-fc67b264842f"
         juris:"CHAR"
         priority:"3"
         sub_type:"OFFICER REQUESTED"
         sub_type_code:"OFFICER"
         type:"ATTEMPT TO LOCATE"
         type_code:"PS-ATL"
         unit_id:"21-1265-1"
         */
        let existing = this.value.find(v => {
          return v[0] === log.cad_event_number
        })
        if(!existing) {
          this.onAddLog({
            0: log.cad_event_number,
            1: log.type_code ? `${log.type_code}`: null,
            2: log.address,
            3: log.sub_type_code,
            4: null,
          })
        }

      })
    })
  }

  syncLenexaCADData(clear = false) {
    if (!this.isEdit) {
      return false
    }
    if (clear) {
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: false,
        list: []
      })
    }
    ApiGet(`/api/v1/lenexa-cad/list-by-user/${this.props.acknowledger.guid}/${this.state.datetime}`).then(res => {
      res.forEach((log) => {
        /***

         arrive_time:"2025-10-06T09:55:54"
         badge_number:"1234"
         call_type:"TEST_CALL"
         case_number:"3455-34534"
         cleared_time:"2025-10-06T09:55:57"
         dispatch_time:"2025-10-06T09:55:44"
         id:"100c754b-f108-4192-aec2-790786d02b69"
         */
        let existing = this.value.find(v => {
          return v[0] === log.case_number
        })
        if(!existing) {
          this.onAddLog({
            0: log.case_number,
            1: formatDate(log.dispatch_time),
            2: log.call_type ? `${log.call_type}`: '',
            3: null,
            4: null,
          })
        }

      })
    })
  }

  openForm() {
    this.setState({
      isFormOpened: true
    }, () => {
      this.onTempAdd({})
    })
  }

  onAddLog(log) {
    if (this.state.editingLogIndex === null || this.state.editingLogIndex < 0) {
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: true,
        list: [...this.value, log]
      });
      this.setState({
        isFormOpened: false
      })
    } else {
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: true,
        list: this.value.map((v, i) => i === this.state.editingLogIndex ? log : v)
      });
      this.setState({
        isFormOpened: false,
        editingLogIndex: null
      })
    }
  }

  onTempAdd(log) {
    if (this.state.editingLogIndex === null || this.state.editingLogIndex < 0) {
      this.setState({
        editingLogIndex: this.props.value.list.length,
        isAdding: true,
      })
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: true,
        list: [...this.value, log]
      });
    } else {
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: true,
        list: this.value.map((v, i) => i === this.state.editingLogIndex ? log : v)
      });
    }
  }

  onCancel() {
    if (this.state.isAdding) {
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: true,
        list: this.value.filter((_, i) => i !== this.state.editingLogIndex)
      });
    } else {
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: true,
        list: this.value.map((v, i) => i === this.state.editingLogIndex ? this.state.editingItem : v)
      });
    }
    this.setState({
      isFormOpened: false,
      editingLogIndex: null
    })
  }

  removeItem(index) {
    let copyVal = [...this.value];
    copyVal.splice(index, 1);
    this.props.onValueChange(this.props.name, {
      ...this.props.value,
      isValid: !!copyVal.length,
      list: copyVal
    })
  }

  getFieldLabel(index) {
    return this.logFieldGenericConfig.fields[index].label;
  }

  getFieldValue(index, v) {
    let l = this.logFieldGenericConfig.fields[index].options.find(({value}) => value === v);
    if (l) {
      return l.label
    }
    return v;
  }

  editItem(index) {
    this.setState({
      editingLogIndex: index,
      isAdding: false,
      editingItem: this.value[index]
    }, () => {
      this.openForm()
    })
  }

  get editingLog() {
    let copyVal = [...this.value];
    return copyVal[this.state.editingLogIndex]
  }

  getFieldValues({date, trainingPhaseHeader, trainingPhaseGuid, reportGuid, groupBy, score, ...field}) {
    console.log('FIELD', field)
    return field
  }

  openReport(e, reportGuid) {
    e.preventDefault()
    e.stopPropagation()
    ApiGet(`/api/v1/reports/${reportGuid}`)
      .then(res => {
        this.props.reportClick(reportModel(res));
      })
  }

  groupLogs(lr, groupBy) {
    let logReport = lr;

    let groupByMap = logReport.fields[groupBy]
      ? logReport.fields[groupBy].options.reduce((acc, o) => ({...acc, [o.value]: []}), {})
      : {}

    let groupedLogs = this.value
      .reduce((acc, log) => {
        if (log[groupBy] && this.props.element.groupBy && ((Array.isArray(this.props.element.groupBy) && this.props.element.groupBy.includes(groupBy)) || (!Array.isArray(this.props.element.groupBy) && this.props.element.groupBy === groupBy))) {
          return {
            ...acc,
            [log[groupBy]]: [
              ...(acc[log[groupBy]] || []),
              log
            ]
          }
        }
        return acc
      }, groupByMap);


    let groupLogs = Object.keys(groupedLogs)
      .map((key) => ({
        key,
        count: groupedLogs[key].length,
      }))
      .sort((q1, q2) => {
        let sortPropA = q1.key;
        let sortPropB = q2.key;
        return collator.compare(sortPropA, sortPropB);
      })
      .map((l) => ({
        ...l,
        key: l.key.split('_').join(' ')
      }))
      .filter((l) => {
        return l.count > 0
      });

    return groupLogs;
  }

  getGroups(lr) {
    let groupBy = lr.groupBy;
    if(!Array.isArray(groupBy)) {
      groupBy = groupBy !== null ? [groupBy]: []
    }
    return groupBy.filter(gb => gb !== null)
  }

  getGroupName(lr, group) {
    try {
      return lr.fields[group].label
    } catch (ex) {
      return "N/A"
    }
  }

  render() {
    return (
      <div className={classNames({"remedial-training-response": true, 'preview': !this.isEdit})}>
        <div className="remedial-training-title">
          {this.props.element.form_title}
        </div>

        {this.props.element.pullTylerCADData && this.isEdit &&
          <div className={"tyler-sync"}>
            <br/>
            <div>
              <button type="button" onClick={() => this.syncCADData()} className={'button small primary'}
                      style={{marginRight: '10px'}}>
                Sync CAD Data
              </button>
              <button type="button" onClick={() => this.syncCADData(true)} className={'button small danger'}
                      style={{marginRight: '10px'}}>
                Sync CAD Data and clear
              </button>

              <input
                className={classNames('form-control')}
                style={{display: 'inline-block', width: 'auto'}}
                type="date"
                value={this.state.datetime}
                onChange={(e) => this.setState({datetime: e.target.value})}
              />
            </div>
          </div>
        }

        {this.props.element.pullIcsCADData && this.isEdit &&
          <div className={"tyler-sync"}>
            <br/>
            <div>
              <button type="button" onClick={() => this.syncIcsCADData()} className={'button small primary'}
                      style={{marginRight: '10px'}}>
                Sync CAD Data
              </button>
              <button type="button" onClick={() => this.syncIcsCADData(true)} className={'button small danger'}
                      style={{marginRight: '10px'}}>
                Sync CAD Data and clear
              </button>

              <input
                className={classNames('form-control')}
                style={{display: 'inline-block', width: 'auto'}}
                type="date"
                value={this.state.datetime}
                onChange={(e) => this.setState({datetime: e.target.value})}
              />
            </div>
          </div>
        }
        {this.props.element.pullCmpdCADData && this.isEdit &&
          <div className={"tyler-sync"}>
            <br/>
            <div>
              <button type="button" onClick={() => this.syncCmpdCADData()} className={'button small primary'}
                      style={{marginRight: '10px'}}>
                Sync CAD Data
              </button>
              <button type="button" onClick={() => this.syncCmpdCADData(true)} className={'button small danger'}
                      style={{marginRight: '10px'}}>
                Sync CAD Data and clear
              </button>

              <input
                className={classNames('form-control')}
                style={{display: 'inline-block', width: 'auto'}}
                type="date"
                value={this.state.datetime}
                onChange={(e) => this.setState({datetime: e.target.value})}
              />
            </div>
          </div>
        }

        {this.props.element.pullLenexaCADData && this.isEdit &&
          <div className={"tyler-sync"}>
            <br/>
            <div>
              <button type="button" onClick={() => this.syncLenexaCADData()} className={'button small primary'}
                      style={{marginRight: '10px'}}>
                Sync CAD Data
              </button>
              <button type="button" onClick={() => this.syncLenexaCADData(true)} className={'button small danger'}
                      style={{marginRight: '10px'}}>
                Sync CAD Data and clear
              </button>

              <input
                className={classNames('form-control')}
                style={{display: 'inline-block', width: 'auto'}}
                type="date"
                value={this.state.datetime}
                onChange={(e) => this.setState({datetime: e.target.value})}
              />
            </div>
          </div>
        }

        <div>
          {this.value.map((field, indexField) => (
            <Fragment key={indexField}>
              {indexField !== this.state.editingLogIndex && (
                <div className="remedial-training-response-item">
                  {field.reportGuid && (
                    <div className="rt-item">
                      <button onClick={(e) => this.openReport(e, field.reportGuid)} className="button small secondary">
                        View report
                      </button>
                    </div>
                  )}
                  {field.trainingPhaseHeader && (
                    <div className="rt-item">
                      <div className="rt-name">
                        Training phase
                      </div>
                      <div className="rt-value">
                        {field.trainingPhaseHeader}
                      </div>
                    </div>
                  )}
                  {field.date && (
                    <div className="rt-item">
                      <div className="rt-name">
                        Date
                      </div>
                      <div className="rt-value">
                        {formatDate(field.date)}
                      </div>
                    </div>
                  )}
                  {Object.values(this.getFieldValues(field)).map((val, index) => (
                    <div className="rt-item" key={index}>
                      {this.logFieldGenericConfig.fields[index].type == 'boolean' &&
                        <DisplayBoolean
                          label={this.getFieldLabel(index)}
                          value={val}
                        />
                      }
                      {this.logFieldGenericConfig.fields[index].type != 'boolean' && this.logFieldGenericConfig.fields[index].type != 'select' &&
                        <Fragment>
                          <div className="rt-name">
                            {this.getFieldLabel(index)}
                          </div>
                          <div className="rt-value">
                            {val}
                          </div>
                        </Fragment>
                      }
                      {this.logFieldGenericConfig.fields[index].type == 'select' &&
                        <Fragment>
                          <div className="rt-name">
                            {this.getFieldLabel(index)}
                          </div>
                          <div className="rt-value">
                            {this.getFieldValue(index, val)}
                          </div>
                        </Fragment>
                      }
                    </div>
                  ))}

                  {this.isEdit && (
                    <div className="rt-item">
                      <button className="button danger small" type="button" onClick={() => this.removeItem(indexField)}>
                        <i className="fa fa-trash"/> Delete log
                      </button>
                      <button className="button secondary small" type="button"
                              onClick={() => this.editItem(indexField)}>
                        <i className="fa fa-pencil"/> Edit log
                      </button>
                    </div>
                  )}
                </div>
              )}

              {indexField === this.state.editingLogIndex && this.state.isFormOpened && this.isEdit && (
                <div>
                  <CustomForm
                    config={this.logFieldGenericConfig}
                    saveLabel={'Save'}
                    saveIcon={'fa fa-plus'}
                    saveSmall={true}
                    initialValues={this.editingLog}
                    cancelAvailable={true}
                    onSubmit={(log) => this.onAddLog(log)}
                    onChange={(log) => this.onTempAdd(log)}
                    onCancel={() => this.onCancel()}
                  />
                </div>
              )}
            </Fragment>

          ))}
        </div>

        {!!this.value.length && this.getGroups(this.logFieldGenericConfig) && this.getGroups(this.logFieldGenericConfig).map((group) => (
          <div key={group + this.logFieldGenericConfig.form_title}>
            <div className="group-name"><b>{this.getGroupName(this.logFieldGenericConfig, group)}</b></div>
            {this.groupLogs(this.logFieldGenericConfig, group).map(lr => (
              <div key={lr.key} className="log-analytics-group" onClick={() => this.toggleGroup(lr.key + ra.user.guid)}>
                <div className="log-analytics-group-header">
                  <span>{lr.key}: {lr.count}</span>
                </div>
              </div>
            ))}
          </div>
        ))}
        {
          !this.state.isFormOpened && this.isEdit && (
            <div className="text-left add-rt">
              <button className="button secondary " type="button" onClick={() => this.openForm()}>
                <i className="fa fa-plus"/> Add log
              </button>
            </div>
          )
        }

        {this.state.isFormOpened && this.isEdit && (this.state.editingLogIndex == null || this.state.editingLogIndex < 0) && (
          <div>
            <CustomForm
              config={this.logFieldGenericConfig}
              saveLabel={'Save'}
              saveIcon={'fa fa-plus'}
              saveSmall={true}
              initialValues={this.editingLog}
              cancelAvailable={true}
              onSubmit={(log) => this.onAddLog(log)}
              onChange={(log) => this.onTempAdd(log)}
              onCancel={() => this.setState({
                isFormOpened: false,
                editingLogIndex: null
              })}
            />
          </div>
        )}
      </div>
    )
  }
}

export default LogFieldResponse;
